'use client'

import { DEFAULT_IMAGE_SIZES, generateSrcset, getImageUrlByWidth } from '@/lib/image-helpers'
import type { StrapiImageMedia } from '@/types/api'
import type { ImageExtendedProps } from '@/types/next'

interface OptimizedImageProps extends Omit<ImageExtendedProps, 'src' | 'alt'> {
	readonly media?: StrapiImageMedia | null
	readonly alt: string
}

export function OptimizedImage({
	media,
	fallbackSrc,
	alt,
	loading = 'lazy',
	fetchPriority = 'auto',
	decoding = 'async',
	...imgProps
}: OptimizedImageProps) {
	if (!media) return null

	const srcset = generateSrcset(media)
	const sizesAttribute = imgProps.sizes ?? DEFAULT_IMAGE_SIZES
	const src = getImageUrlByWidth(media, imgProps?.width) ?? fallbackSrc ?? undefined

	return (
		// biome-ignore lint/performance/noImgElement: OptimizedImage wrapper component manages optimization
		<img
			{...imgProps}
			src={src}
			alt={alt}
			loading={loading}
			fetchPriority={fetchPriority}
			decoding={decoding}
			srcSet={srcset}
			sizes={sizesAttribute}
		/>
	)
}
